/**
 * 面试pdf导出
 * @description 面试pdf导出
 * @author mll
 * @date 2022-07-14
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool';
import { exportPdf } from '@/utils';
import '@/styles/containers/interview/resumeExport.less';
import { ResumeExportView } from '@/components';

let { Session } = utils_tool;
let { WizContainer, modelUtils } = framework_tool;
let { WizSpin, WizButton } = component_tool;

class ResumeExport extends WizContainer {
  componentName = 'ResumeExport';

  constructor(props) {
    super(props);
    this.state = { base: {}, leida: {} };
    let record = {},
      { history } = props;
    if (
      history.location &&
      history.location.pathname === '/interview/resume/export'
    ) {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('ResumeExport', record);
      } else {
        record = Session.get('ResumeExport') || {};
      }
    }
    this.record = record;
  }

  _componentWillMount() {
    this._getData();
  }

  _getData = () => {
    this.doAction({
      path: 'interviewResume/exportPDF',
      payload: {
        key: 'interviewResume@exportPDF',
        apiParams: {
          id: this.record.id
        }
      }
    });
  };

  propsAndStateOnChange = {
    resume: this._resume.bind(this)
  };

  _resume(nextProps, nextState) {
    let { code, msg, data } = nextProps.resume;
    if (code == 1) {
      nextState['base'] = data['base'];
      nextState['leida'] = data['leida'];
      return true;
    } else {
      wizNotice.error(msg || '获取简历失败');
    }
    return false;
  }

  _render() {
    let { interviewResumeLoading } = this.props;
    let { base, leida } = this.state;
    return (
      <WizSpin tip={'加载中'} spinning={interviewResumeLoading}>
        <div className="export">
          <WizButton
            className="export-btn"
            disabled={!this.state.base.name}
            onClick={() => {
              wizNotice.info('PDF生成中,请稍后...');
              exportPdf(
                `简历导出-${base.name}`,
                document.getElementById('pdf-export')
              );
            }}
          >
            PDF导出
          </WizButton>
          <div className="export-main" id="pdf-export">
            <ResumeExportView data={base} leida={leida} />
          </div>
        </div>
      </WizSpin>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { interviewResume } = state;
  const resume = modelUtils.getModelEntity(
    interviewResume,
    'interviewResume@exportPDF'
  );
  const load = modelUtils.getLoadingState(state, 'interviewResume');
  return {
    resume,
    ...load
  };
};

export default connect(mapStateToProps)(ResumeExport);
